import { Component, AfterViewInit, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/internal/Observable';
import { Subscriber } from 'rxjs/internal/Subscriber';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { invalid } from '@angular/compiler/src/render3/view/util';
import { HttpErrorResponse } from '@angular/common/http';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { SafeUrl } from '@angular/platform-browser';
import { finalize } from 'rxjs/operators';
@Component({
  selector: 'app-photo-signature-details',
  templateUrl: './photo-signature-details.component.html',
  styleUrls: ['./photo-signature-details.component.scss']
})
export class PhotoSignatureDetailsComponent implements OnInit {
  @Output() next = new EventEmitter<void>();
  @Output() prev = new EventEmitter<void>();
  @Output() first = new EventEmitter<void>();
  @Input() tabName: string = '';
  dialogRef: MatDialogRef<any>;
  userImage: any;
  errormessage: string;
  signatureImage: any;
  userSign: string;
  fileName: string;
  uploadDoc: any;
  proId: any;
  disabled = false;
  tabs: string;
  displayName: any;
  Course: any;
  College: any;
  isSaving: boolean = false;
  imageChangedEvent: Event | null = null;
  croppedImage: SafeUrl = '';
  singExt: string;
  photoExt: string;
   readonly PHOTO_MIN_WIDTH = 200;
  readonly PHOTO_MIN_HEIGHT = 230;
  readonly PHOTO_MAX_WIDTH = 500;
  readonly PHOTO_MAX_HEIGHT = 530;
  readonly PHOTO_MAX_SIZE_KB = 50; // 50KB max for photo
  
  readonly SIGNATURE_MIN_WIDTH = 140;
  readonly SIGNATURE_MIN_HEIGHT = 60;
  readonly SIGNATURE_MAX_WIDTH = 300;
  readonly SIGNATURE_MAX_HEIGHT = 300;
  readonly SIGNATURE_MAX_SIZE_KB = 20; // 20KB max for signature

  constructor(private fb: FormBuilder, private modalPopupService: ModalpopService,
    public umsService: UmsService, private spinner: NgxSpinnerService) { }
  photoSignDetailsForm: FormGroup;
  submitButton = true;
  updateButton = false;
  showmsg = false
  StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
  studentId = sessionStorage.getItem('StudentRGID');
    photoActualWidth: number = 0;
  photoActualHeight: number = 0;
  signatureActualWidth: number = 0;
  signatureActualHeight: number = 0;
  
 

  ngOnInit(): void {
    this.StudentPersonalId = sessionStorage.getItem('StudentPersonalId');
    this.submitButton = true;
    this.updateButton = false;
    this.disabled = false;
    this.photoSignDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentPersonalId),
      StuRgNo: new FormControl(this.studentId),
      StuPhoto: new FormControl('', Validators.required),
      StuSignature: new FormControl('', Validators.required),
 
    });
    this.prepopulation();
    this.getScrutiny();
    this.getApplyData();
    // this.userImage = "../../assets/images/user2.png";
    // this.signatureImage ="../../assets/images/sign.png";
  }

  getScrutiny() {
    const payload = {};
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe(res => {
      this.tabs = res.data[0].Tabs;
      // if(res.data.length == 0 || res.data[0]['Status'] == 'DCERR'){
      //   this.disabled = false
      // }
      // else{
      //   this.disabled = true;
      // }
      if (res.data.length == 0 || res.data[0]['Status'] == 'DCERR') {
        if (res.data[0].Tabs.includes('Photo & Signatur')) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      }
      else {
        this.disabled = true;
      }
    });
  }

  submitCheck() {
    if ((this.userImage == '' && this.signatureImage == '') || (this.userImage == null && this.signatureImage == null)) {
      this.photoSignDetailsForm.get('StuSignature').markAsTouched();
      this.photoSignDetailsForm.get('StuPhoto').markAsTouched();

    }
    else if ((this.userImage == null || this.userImage == '') && (this.signatureImage != null || this.signatureImage != '')) {
      // this.photoSignDetailsForm.get('StuSignature').markAsTouched();
      this.photoSignDetailsForm.get('StuPhoto').markAsTouched();

    }
    else if ((this.userImage != null || this.userImage != '') && (this.signatureImage == null || this.signatureImage == '')) {
      this.photoSignDetailsForm.get('StuSignature').markAsTouched();
      // this.photoSignDetailsForm.get('StuPhoto').markAsTouched();

    }
    else {
      this.save();
      this.saveFiles();
    }
  }

  saveFiles() {
    const payload = {
      StuId: parseInt(this.photoSignDetailsForm.value.StuId),
      StuRgNo: parseInt(this.photoSignDetailsForm.value.StuRgNo),
      files: [
        {
          fileName: "photo." + this.photoExt,
          base64Data: this.userImage
        },
        {
          fileName: "sign." + this.singExt,
          base64Data: this.signatureImage
        }
      ]
    };
    this.umsService.saveFilesDetails(payload).subscribe(
      res => {
        if (res.status) {
          this.spinner.hide();
        } else {
          this.isSaving = false;
          this.spinner.hide();
        }
      },
      (error: HttpErrorResponse) => {
        this.isSaving = false;
        this.spinner.hide();
      }
    );

  }

  save() {
    this.isSaving = true;
    this.submitButton = true;
    this.updateButton = false;
    const payload = this.photoSignDetailsForm.value;
    payload.StuId = parseInt(payload.StuId);
    payload.StuRgNo = parseInt(payload.StuRgNo);
    payload.StuPhoto = "photo." + this.photoExt;
    payload.StuSignature = "sign." + this.singExt;
    payload.LoginId = parseInt(sessionStorage.getItem('StudentRGID'));
    if (payload.StuPhoto == '') {
      let img = '../../assets/images/user2.png'
      sessionStorage.setItem('ProfileImg', img);
      this.umsService.getNoimg(img)
    } else {
      sessionStorage.setItem('ProfileImg', this.userImage);
    }

    this.umsService.addPhotoSignDetails(payload).subscribe(res => {
      if (res.status) {
        this.isSaving = false;
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
        this.next.emit();
      }
      else {
        this.isSaving = false;
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.isSaving = false;
      this.spinner.hide();
    });
  }

  getFiles(data) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    payload['fileNames'] = [data[0].StuPhoto, data[0].StuSignature];

    this.umsService.getFilesDetails(payload).subscribe((res) => {
      this.spinner.hide();
        this.umsService.disable6 = false;
        this.submitButton = false;
        this.updateButton = true;
        const files = res.files || [];

        const photoFile = files.find((f: any) =>
          f.fileName?.toLowerCase().includes('photo') || f.fileName?.toLowerCase().includes('stu')
        );
        const signFile = files.find((f: any) =>
          f.fileName?.toLowerCase().includes('sign') || f.fileName?.toLowerCase().includes('signature')
        );

        this.userImage = photoFile?.base64Data || '';
        this.signatureImage = signFile?.base64Data || '';

        //Prepopulate form values so they match the displayed images
        this.photoSignDetailsForm.patchValue({
          // StuPhoto: this.userImage,
          // StuSignature: this.signatureImage
          StuPhoto: new FormControl(this.userImage, Validators.required),
          StuSignature: new FormControl(this.signatureImage, Validators.required),
        });
        sessionStorage.setItem('ProfileImg', this.userImage || '../../assets/images/user2.png');
    });
  }

  prepopulation() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      // sessionStorage.setItem('ProfileImg', res.data[0].StuPhoto);
      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      this.spinner.hide();
      if (res.status) {
        if (res.data.length > 0) {
          this.umsService.disable6 = false;
          this.submitButton = false;
          this.updateButton = true;
          if (res.data[0].StuPhoto && res.data[0].StuPhoto.startsWith('data:')) {
          this.userImage = res.data[0].StuPhoto;
          this.signatureImage = res.data[0].StuSignature;
          this.photoSignDetailsForm.patchValue({
            StuPhoto: new FormControl(this.userImage, Validators.required),
            StuSignature: new FormControl(this.signatureImage, Validators.required),
          });
          sessionStorage.setItem('ProfileImg', this.userImage || '../../assets/images/user2.png');
        } else {
          this.getFiles(res.data);
        }

          
        }
        else {
          this.submitButton = true;
          this.updateButton = false;

        }
      }
    })
  }

  prepopulation2() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentPersonalId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      this.spinner.hide();
      sessionStorage.setItem('ProfileImg', res.data[0].StuPhoto);
      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      if (res.status) {
        if (res.data.length > 0) {
          this.umsService.disable6 = false;
        }
        else {
          this.umsService.disable5 = true;
        }
      } else {

      }
    })
  }

  updateCheck() {
    if (this.userImage == '' || this.userImage == null || this.signatureImage == '' || this.signatureImage == null) {
      this.photoSignDetailsForm.get('StuSignature').markAsTouched();
      this.photoSignDetailsForm.get('StuPhoto').markAsTouched();

    } else {
      this.update();
      this.saveFiles()
    }
  }
  getTabDisplayName(): string {
    return `Current Tab: ${this.tabName}`;
  }

  update() {
    if (this.tabs) {
      const lastTab: string = this.tabs.split(', ').pop() || '';


      if (this.tabName == lastTab) {
        const data = {};
        data['message'] = 'Are You Sure You Have Updated ' + this.tabs + ' Tabs. Do You Want To Proceed?';
        data['title'] = 'Alert';
        data['icon'] = 'fa fa-question';
        this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          if (result === 'yes') {
            this.UpdScrtDetails();
            this.UpdateScrutiny();
          } else {
            this.dialogRef.close();
            // Do something else if needed
          }
        });
      }
      else {
        this.UpdateScrutiny();
      }
    }
    else {
      this.UpdateScrutiny();
    }

  }
  UpdateScrutiny(){
  this.spinner.show();
  let payload = this.photoSignDetailsForm.value;
  payload.StuId = parseInt(payload.StuId);
  payload.StuRgNo = parseInt(payload.StuRgNo);
  payload.StuPhoto = "photo." + this.photoExt;
    payload.StuSignature = "sign." + this.singExt;
  payload['StuProfId'] = this.proId;
  sessionStorage.setItem('ProfileImg',this.userImage);
  payload.LoginId = parseInt(sessionStorage.getItem('StudentRGID'));
  this.umsService.updatePhotoSignDetails(payload).subscribe(res => {
    if(res.status){
      if(payload.StuPhoto == ''){
        let img = '../../assets/images/user2.png'
        sessionStorage.setItem('ProfileImg','../../assets/images/user2.png');
        this.umsService.getNoimg(img);
        
        
      }else{
        sessionStorage.setItem('ProfileImg',payload.StuPhoto);
        
      }
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);  
      this.next.emit();
  
    }
    
  });
}

  // onChange1($event: Event) {
  //   const file = ($event.target as HTMLInputElement).files[0];
  //   const fileName = file.name;
  //   this.fileName = fileName;
  //   if (file.size >= 3000000) {
  //     // this.apimicroservice.openSnackbar("Max upload size allowed is 3mb");
  //     this.errormessage = "Please upload file less than 3 MB";

  //     let data = {}
  //     data['message'] = this.errormessage;
  //     data['title'] = 'Information';
  //     data['icon'] = 'fas fa-close';
  //     this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  //     this.dialogRef.afterClosed().subscribe(result => {
  //       // this.dialogRef.close();
  //       // this.ngOnInit();
  //       // this.dialogRef2.close();
  //     });

  //   } else {
  //     this.errormessage = '';
  //     this.photoExt = fileName.substring(fileName.lastIndexOf(".") + 1);

  //     if (
  //       this.photoExt.toLowerCase() == "png" ||
  //       this.photoExt.toLowerCase() == "jpg" ||
  //       this.photoExt.toLowerCase() == "jpeg"
  //       // ext.toLowerCase() == "pdf"
  //     ) {

  //       this.convertToBase641(file);
  //     }
  //     else {
  //       let data = {}
  //       data['message'] = 'File not support'
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-close'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  //       this.dialogRef.afterClosed().subscribe(result => {
  //         // this.dialogRef.close();
  //         // this.ngOnInit();
  //         // this.dialogRef2.close();
  //       });
  //     }
  //   }
  // }
  onChange1($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    if (!file) return;

    const fileName = file.name;
    this.fileName = fileName;
    this.photoExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    if (!['jpg', 'jpeg'].includes(this.photoExt)) {
      this.showErrorDialog('File not supported. Please upload JPG or JPEG image only for photo.');
      return;
    }
    this.photoActualWidth = 0;
    this.photoActualHeight = 0;
    this.validateImageDimensions(file, 'photo').then(({ isValid, width, height, message }) => {
      if (!isValid) {
        this.showErrorDialog(message);
        return;
      }

      if (message) {
        this.showInfoDialog(message);
      }

      this.convertToBase641(file);
    });
  }

  onChangeSign($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    if (!file) return;

    const fileName = file.name;
    this.fileName = fileName;
    this.singExt = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
    if (!['jpg', 'jpeg'].includes(this.singExt)) {
      this.showErrorDialog('File not supported. Please upload JPG or JPEG image only for signature.');
      return;
    }
    this.signatureActualWidth = 0;
    this.signatureActualHeight = 0;
    this.validateImageDimensions(file, 'signature').then(({ isValid, width, height, message }) => {
      if (!isValid) {
        this.showErrorDialog(message);
        return;
      }

      if (message) {
        this.showInfoDialog(message);
      }

      this.convertToBase64Sign(file);
    });
  }

  // convertToBase641(file: File) {
  //   const observable = new Observable((subscriber: Subscriber<any>) => {
  //     this.readFile1(file, subscriber);
  //   });

  //   observable.subscribe((d) => {
  //     this.userImage = d;
  //     if (this.userImage == '' || this.userImage == null) {
  //       // this.photoSignDetailsForm.get('StuSignature').markAsTouched();
  //       this.photoSignDetailsForm.get('StuPhoto').markAsTouched();
  //     } else {
  //       // this.photoSignDetailsForm.get('StuSignature').markAsUntouched();
  //       this.photoSignDetailsForm.get('StuPhoto').markAsUntouched();
  //     }

  //   });
  // }
  
  convertToBase641(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile1(file, subscriber);
    });

    observable.subscribe((base64Data: string) => {
      this.userImage = base64Data;
      this.photoSignDetailsForm.get('StuPhoto')?.setValue(base64Data);

      if (!this.userImage) {
        this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
      } else {
        this.photoSignDetailsForm.get('StuPhoto')?.markAsUntouched();
      }
    });
  }

  // convertToBase641(file: File) {
  //   const observable = new Observable((subscriber: Subscriber<any>) => {
  //     this.readFile1(file, subscriber);
  //   });

  //   observable.subscribe((base64Data: string) => {
  //     this.userImage = base64Data;

  //     // Update the form control value
  //     this.photoSignDetailsForm.get('StuPhoto')?.setValue(base64Data);

  //     if (!this.userImage) {
  //       this.photoSignDetailsForm.get('StuPhoto')?.markAsTouched();
  //     } else {
  //       this.photoSignDetailsForm.get('StuPhoto')?.markAsUntouched();
  //     }
  //   });
  // }

  readFile1(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }


  // onChangeSign($event: Event) {
  //   const file = ($event.target as HTMLInputElement).files[0];
  //   const fileName = file.name;
  //   this.fileName = fileName;
  //   if (file.size >= 3000000) {
  //     // this.apimicroservice.openSnackbar("Max upload size allowed is 3mb");
  //     this.errormessage = "Please upload file less than 3 MB";
  //     let data = {}
  //     data['message'] = this.errormessage
  //     data['title'] = 'Information'
  //     data['icon'] = 'fas fa-close'
  //     this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  //     this.dialogRef.afterClosed().subscribe(result => {
  //       // this.dialogRef.close();
  //       // this.ngOnInit();
  //       // this.dialogRef2.close();

  //       // this.qualificationDetailsForm.controls['fileUploadData'].setValue('');
  //     });
  //   } else {
  //     this.errormessage = '';
  //     this.singExt = fileName.substring(fileName.lastIndexOf(".") + 1);

  //     if (
  //       this.singExt.toLowerCase() == "png" ||
  //       this.singExt.toLowerCase() == "jpg" ||
  //       this.singExt.toLowerCase() == "jpeg"
  //       // ext.toLowerCase() == "pdf"
  //     ) {

  //       this.convertToBase64Sign(file);
  //     }
  //     else {
  //       let data = {}
  //       data['message'] = 'File not support'
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-close'
  //       this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  //       this.dialogRef.afterClosed().subscribe(result => {
  //         // this.dialogRef.close();
  //         // this.ngOnInit();
  //         // this.dialogRef2.close();
  //       });
  //     }
  //   }
  // }
  convertToBase64Sign(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile1(file, subscriber);
    });

    observable.subscribe((d) => {
      this.signatureImage = d;
      if (this.signatureImage == '' || this.signatureImage == null) {
        this.photoSignDetailsForm.get('StuSignature').markAsTouched();
        // this.photoSignDetailsForm.get('StuPhoto').markAsTouched();
      } else {
        this.photoSignDetailsForm.get('StuSignature').markAsUntouched();
        // this.photoSignDetailsForm.get('StuPhoto').markAsUntouched();
      }
    });
  }
  readFileSign(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }
  back() {
    this.prev.emit();
  }
  UpdScrtDetails() {
    let payload = {};
    payload['StuId'] = parseInt(this.StudentPersonalId)
    payload['SessionId'] = parseInt(sessionStorage.getItem('session'));
    payload['CgCode'] = this.College
    payload['CoCode'] = this.Course
    this.umsService.UpdScrtDetails(payload).subscribe((res) => {
      if (res.status) {
        this.first.emit();
        location.reload();
      }
      else {

      }
    })
  }
  getApplyData() {
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      if (res.status) {
        this.Course = res.data[0]['Course'];
        this.College = res.data[0]['College']
      }
      else {

      }
    }, (ERROR: HttpErrorResponse) => {

    });
  }


  fileChangeEvent(event: Event): void {
    this.imageChangedEvent = event;
  }
 
    validateImageDimensions(file: File, type: 'photo' | 'signature'): Promise<{ isValid: boolean; width: number; height: number; message?: string }> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const minWidth = type === 'photo' ? this.PHOTO_MIN_WIDTH : this.SIGNATURE_MIN_WIDTH;
        const minHeight = type === 'photo' ? this.PHOTO_MIN_HEIGHT : this.SIGNATURE_MIN_HEIGHT;
        const maxWidth = type === 'photo' ? this.PHOTO_MAX_WIDTH : this.SIGNATURE_MAX_WIDTH;
        const maxHeight = type === 'photo' ? this.PHOTO_MAX_HEIGHT : this.SIGNATURE_MAX_HEIGHT;
        const maxSizeKB = type === 'photo' ? this.PHOTO_MAX_SIZE_KB : this.SIGNATURE_MAX_SIZE_KB;
        const fileSizeKB = file.size / 1024;
        
        
        if (type === 'photo') {
          this.photoActualWidth = img.width;
          this.photoActualHeight = img.height;
        } else {
          this.signatureActualWidth = img.width;
          this.signatureActualHeight = img.height;
        }
        
      
        if (fileSizeKB > maxSizeKB) {
          resolve({ 
            isValid: false, 
            width: img.width, 
            height: img.height,
            message: `File size exceeds limit. Maximum allowed: ${maxSizeKB}KB. Your file: ${fileSizeKB.toFixed(2)}KB.`
          });
          URL.revokeObjectURL(img.src);
          return;
        }
        
        const widthInRange = img.width >= minWidth && img.width <= maxWidth;
        const heightInRange = img.height >= minHeight && img.height <= maxHeight;
        
        const isWidthValid = widthInRange && img.height >= minHeight;
        const isHeightValid = heightInRange && img.width >= minWidth;
        
        let isValid = false;
        let message = '';
        
        if (isWidthValid || isHeightValid) {
          isValid = true;
          
          
          if (img.width === minWidth && img.height === minHeight) {
            message = `Image uploaded successfully`;
          } else if (img.width === maxWidth && img.height === maxHeight) {
            message = `Image uploaded successfully`;
          } else if (img.width === minWidth || img.width === maxWidth) {
            message = `Image uploaded successfully`;
          } else if (img.height === minHeight || img.height === maxHeight) {
            message = ` Image uploaded successfully`;
          } else if (widthInRange && heightInRange) {
            message = `Image uploaded successfully`;
          } else if (isWidthValid) {
            message = `Image uploaded successfully `;
          } else if (isHeightValid) {
            message = ` Image uploaded successfully `;
          }
        } else {
          isValid = false;
          
          
          if (img.width < minWidth) {
            message = `Width is too small. Minimum required: ${minWidth}px.`;
          } else if (img.width > maxWidth) {
            message = `Width is too large. Maximum allowed: ${maxWidth}px.`;
          } else if (img.height < minHeight) {
            message = `Height is too small. Minimum required: ${minHeight}px.`;
          } else if (img.height > maxHeight) {
            message = `Height is too large. Maximum allowed: ${maxHeight}px.`;
          }
        }
        
        resolve({ 
          isValid, 
          width: img.width, 
          height: img.height,
          message 
        });
        
        URL.revokeObjectURL(img.src);
      };
      img.onerror = () => {
        resolve({ isValid: false, width: 0, height: 0, message: 'Failed to load image' });
        URL.revokeObjectURL(img.src);
      };
      img.src = URL.createObjectURL(file);
    });
  }
   private showErrorDialog(message: string): void {
    const data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
    this.dialogRef.afterClosed().subscribe(() => {});
  }

  private showInfoDialog(message: string): void {
    const data = {
      message: message,
      title: 'Information',
      icon: 'fas fa-info-circle'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertboxComponent>(AlertboxComponent, data);
  }

}